import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import * as ReactRedux from 'react-redux'
import * as Urql from 'urql'
import * as R from 'ramda'
import gql from 'graphql-tag'

import * as Common from '@rushplay/common'

import * as Session from './session'
import { GameInfo } from './game-info'
import { GameInfoSeoContent } from './game-info-seo-content'
import { GameLauncher } from './game-launcher'
import { GameWrapper } from './game-wrapper'
import { SimilarGamesSection } from './similar-games-section'
import { useGameInfoUrlQuery } from './use-game-info-url-query'

const getGame = gql`
  query Game($id: ID!) {
    game(id: $id) {
      id
      key
      loginRequired
      liveCasinoGame
    }
  }
`

function GameInfoPage() {
  const params = ReactRouter.useParams()
  const authenticated = ReactRedux.useSelector(state =>
    Session.isAuthenticated(state.session)
  )
  const gameInfoQuery = useGameInfoUrlQuery()

  const { gameId } = ReactRouter.useParams()
  const [response] = Urql.useQuery({
    query: getGame,
    variables: { id: gameId },
  })

  const liveCasinoGame =
    R.equals('live-casino', gameInfoQuery.referrer) ||
    R.pathOr(false, ['game', 'liveCasinoGame'], response.data)

  if (response.fetching) {
    return null
  }

  if (authenticated || (!liveCasinoGame && !authenticated)) {
    return (
      <GameWrapper>
        <GameLauncher />
      </GameWrapper>
    )
  }

  return (
    <Common.Box
      flexBasis="0"
      flexGrow="1"
      flexShrink="1"
      overflowX="hidden"
      display="flex"
      flexDirection="column"
    >
      <GameInfo />
      <Common.Box
        py={2}
        px={{ lg: 1 }}
        minHeight="277px"
        display="flex"
        flexDirection="column"
      >
        <SimilarGamesSection />

        {!authenticated && (
          <GameInfoSeoContent
            translationKey={`game-info-page.seo-content.${params.gameId}`}
          />
        )}
      </Common.Box>
    </Common.Box>
  )
}

// for @loadable/components
export default GameInfoPage
